import React from 'react';
import style from './Menu.module.css';
import { ItemMenu } from './ItemMenu';

interface ISidebar {
    isOpen: boolean;
    onClose: () => void;
    clickHome: () => void;
    clickCursos: () => void;
    clickGraduacao: () => void;
    clickPosGraduacao: () => void;
    clickCertificado: () => void;
    clickSobre: () => void;
}

export const Sidebar: React.FC<ISidebar> = ({ isOpen, onClose, ...props }) => {
    if (!isOpen) return null;

    return (
        <div style={{
            position: 'fixed', top: 0, right: 0, width: '250px', height: '100%', 
            backgroundColor: 'var(--first-color)', zIndex: 1000, display: 'flex', 
            flexDirection: 'column', padding: '60px 20px', gap: '20px', boxShadow: '-5px 0 15px rgba(0,0,0,0.2)'
        }}>
            <button onClick={onClose} style={{ position: 'absolute', top: 20, right: 20, background: 'none', border: 'none', color: 'white', fontSize: '24px' }}>✕</button>
            <ItemMenu click={() => { props.clickHome(); onClose(); }} nome="Home" />
            <ItemMenu click={() => { props.clickCursos(); onClose(); }} nome="Cursos" />
            <ItemMenu click={() => { props.clickGraduacao(); onClose(); }} nome="Graduação" />
            <ItemMenu click={() => { props.clickPosGraduacao(); onClose(); }} nome="Pós-Graduação" />
            <ItemMenu click={() => { props.clickCertificado(); onClose(); }} nome="Certificado" />
            <ItemMenu click={() => { props.clickSobre(); onClose(); }} nome="Sobre" />
        </div>
    );
};
